import React, { Component } from 'react';
import { GridTable } from '../Sidebar/SidebarStyles';
import { Table, TableBody, TableCell, TableHead, TableRow, Button, Box, Paper, TableContainer, TablePagination, Grid, Typography, MenuItem, Select, FormControl, CircularProgress } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { fetchNewBrokerOptionData } from '../ApiSevices/ExdionAdminApi'

interface State {
    selectedBroker: any;
    brokerList: any[];
    loading: boolean;
}

interface Props {
    onAdd: (data: any) => void;
    onEdit: (data: any) => void;
    brokerOption: any[]
}

class BrokerTable extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            selectedBroker: '',
            brokerList: [],
            loading: false
        }
    }

    componentDidMount() {
        this.fetchBrokerOptionData();
    }

    fetchBrokerOptionData = async (brokerId?: string | number) => {
        this.setState({ loading: true });
        try {
            const fetchResponse = await fetchNewBrokerOptionData(brokerId);
            if (fetchResponse && fetchResponse?.length > 0) {
                // const uniqueBrokers = Array.from(
                //     new Map(fetchResponse.map((item: any) => [item?.BrokerID, item])).values()
                // );

                this.setState({ brokerList: fetchResponse });
            } else {
                this.setState({ brokerList: [] });
            }
        } catch (error) {
            console.error('Error fetching brokerData:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { onAdd, onEdit, brokerOption } = this.props;
        const { loading, brokerList } = this.state;

        return (
            <div style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ddd' }}>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}
                <div style={{
                    marginBottom: '20px',
                    margin: '7px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '2px',
                    padding: '10px',
                    backgroundColor: '#fcfcfc', boxShadow: 'rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em'
                }}>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} sm={2} md={1.5}>
                            <Typography
                                sx={{
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                Select Broker
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={4} md={3.5}>
                            <FormControl fullWidth size='small'>
                                <Select value={this.state.selectedBroker}
                                    displayEmpty
                                    onChange={(e) => {
                                        const selected = e.target.value;
                                        this.setState({ selectedBroker: selected });
                                        this.fetchBrokerOptionData(selected);
                                    }}
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            return <span style={{ color: '#88888863', fontSize: '12px' }}>Select Broker</span>;
                                        }
                                        const selectedBrokerObj = brokerOption?.find((b: any) => b?.Broker_ID === selected);
                                        return <span style={{ fontSize: '12px' }}>{selectedBrokerObj?.vchBrokerName || selected}</span>;
                                    }}
                                    sx={{
                                        fontSize: { xs: '12px', sm: '12px' },
                                        height: { xs: 36, sm: 32 },
                                    }}>
                                    <MenuItem value="" sx={{ fontSize: '12px' }}>Select Broker</MenuItem>
                                    {brokerOption?.map((broker: any) => (
                                        <MenuItem
                                            key={broker.Broker_ID}
                                            value={broker.Broker_ID}
                                            sx={{ fontSize: '12px' }}
                                        >
                                            {broker?.vchBrokerName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </div>

                <div style={{ padding: '6px', backgroundColor: '#fff', borderRadius: '10px', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)' }}>
                    <Paper sx={{ width: '100%', mb: 2, overflow: 'hidden', border: '0.5px solid #7a6e6e54' }}>
                        <Box sx={{ maxHeight: 340, overflowX: 'auto' }}>
                            <TableContainer sx={{ minWidth: 'max-content' }}>
                                <Table stickyHeader sx={{ height: '45px' }} size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontSize: '11px', width: 60, fontWeight: 'bold', textAlign: 'center' }}>S.No</TableCell>
                                            <TableCell sx={{
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                                width: 130,
                                                minWidth: 130
                                            }}>Broker Name</TableCell>
                                            <TableCell sx={{
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                                width: 130,
                                                minWidth: 130
                                            }}>Phone No</TableCell>
                                            <TableCell sx={{
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                                width: 210,
                                                minWidth: 210
                                            }}>Email ID</TableCell>
                                            <TableCell sx={{
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                                width: 130,
                                                minWidth: 130
                                            }}>Contact Person</TableCell>
                                            <TableCell sx={{
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                                width: 130,
                                                minWidth: 130
                                            }}>Mobile No</TableCell>
                                            <TableCell sx={{
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                                width: 130,
                                                minWidth: 130
                                            }}>Payment Option</TableCell>
                                            <TableCell sx={{
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                                width: 130,
                                                minWidth: 130
                                            }}>Credit/Invoice</TableCell>
                                            <TableCell sx={{
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                                width: 130,
                                                minWidth: 130
                                            }}>Add Credit</TableCell>
                                            <TableCell sx={{
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                                width: 150,
                                                minWidth: 150
                                            }}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>

                                </Table>

                                <Box sx={{ maxHeight: 280, overflowY: 'auto', overflowX: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none', }, }}>
                                    <Table size="small">
                                        <TableBody>
                                            {brokerList?.length === 0 ? (
                                                <TableRow>
                                                    <TableCell align="center"
                                                        sx={{
                                                            fontSize: '14px',
                                                            fontWeight: 500,
                                                            color: 'gray',
                                                            padding: '20px',
                                                            borderBottom: 'none',
                                                        }}>
                                                        No records to display
                                                    </TableCell>
                                                </TableRow>
                                            ) : (brokerList?.map((row: any, index: any) => {
                                                const tblRowList = brokerOption?.find(row => row?.Broker_ID === row?.BrokerID);
                                                const fullRowData = { ...tblRowList, ...row };

                                                return (
                                                    <TableRow key={index}>
                                                        <TableCell sx={{ fontSize: '11px', width: 60, textAlign: 'center' }}>
                                                            {index + 1}
                                                        </TableCell>

                                                        <TableCell
                                                            sx={{
                                                                fontSize: '11px',
                                                                width: 130,
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                textAlign: "center"
                                                            }}
                                                        >
                                                            {row?.vchBroker_Name}
                                                        </TableCell>

                                                        <TableCell sx={{ fontSize: '11px', width: 130, textAlign: "center" }}>
                                                            {row?.vchBusiness_Phone}
                                                        </TableCell>

                                                        <TableCell sx={{ fontSize: '11px', width: 210, textAlign: "center" }}>
                                                            {row?.vchContact_Email}
                                                        </TableCell>

                                                        <TableCell sx={{
                                                            fontSize: '11px', width: 130, textAlign: "center"
                                                        }}>
                                                            {row?.ContactPerson}
                                                        </TableCell>

                                                        <TableCell sx={{
                                                            fontSize: '11px', width: 130, textAlign: "center"
                                                        }}>
                                                            {row?.vchContact_Mobile}
                                                        </TableCell>

                                                        <TableCell sx={{ fontSize: '11px', width: 130, textAlign: "center" }}>
                                                            {row?.payment}
                                                        </TableCell>

                                                        <TableCell sx={{ fontSize: '11px', width: 130, textAlign: "center" }}>
                                                            {row?.Credited == null? "" : row?.Credited === 1 ? "Invoice Based" : "Prepayment"}
                                                        </TableCell>

                                                        <TableCell sx={{
                                                            fontSize: '11px',
                                                            width: 130,
                                                            maxWidth: 130,
                                                            textAlign: "center",
                                                        }}>
                                                            {row?.addCredit}
                                                        </TableCell>
                                                        <TableCell sx={{
                                                            fontSize: '11px',
                                                            width: 150,
                                                            maxWidth: 150,
                                                            textAlign: "center",
                                                        }}>
                                                            {Object.values(row)?.slice(2)?.filter(v => v !== null && v !== "")?.length === 0 ? (
                                                                <Button
                                                                    variant="contained"
                                                                    size="small"
                                                                    onClick={() => onAdd(fullRowData)}
                                                                    sx={{
                                                                        backgroundColor: '#1e1466',
                                                                        fontSize: '11px',
                                                                        padding: '2px 12px',
                                                                        minWidth: 60,
                                                                        height: 28,
                                                                        mt: 1,
                                                                        textTransform: 'none'
                                                                    }}
                                                                >
                                                                    <span style={{ position: 'relative', top: '-3px', left: '-5px', fontSize: '19px' }}>+</span> Add
                                                                </Button>
                                                            ) : (
                                                                <Button
                                                                    variant="contained"
                                                                    size="small"
                                                                    onClick={() => onEdit(row)}
                                                                    sx={{
                                                                        backgroundColor: '#1e1466',
                                                                        fontSize: '11px',
                                                                        padding: '2px 9px',
                                                                        minWidth: 60,
                                                                        height: 28,
                                                                        mt: 1,
                                                                        textTransform: 'none'
                                                                    }}
                                                                    startIcon={<EditIcon sx={{ fontSize: '0px' }} />}
                                                                >
                                                                    Edit
                                                                </Button>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            )}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </TableContainer>
                        </Box>

                        {/* <TablePagination
                            component="div"
                            count={totalCount}
                            page={page}
                            onPageChange={this.handlePageChange}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={this.handleRowsPerPageChange}
                            rowsPerPageOptions={[10, 25, 50, 100, 200]}
                        /> */}
                    </Paper>
                </div>
            </div>
        )
    }
};

export default BrokerTable;
